<template>
  <b-form
    class="form-inline d-flex justify-content-end mb-4"
    :class="cardClass"
    @submit.prevent="$emit('filtrar', filtro)"
  >
    <slot name="filtro-comum">
      <div class="form-group mx-sm-3 mb-2" v-if="exibeFiltro">
        <label class="sr-only">label</label>
        <div class="border-gradient">
          <input type="text" v-model="filtro" class="form-control form-control-placeholdericon" :placeholder="'\uf002 '+titulo">
        </div>
      </div>
    </slot>
    <slot name="botao-acao-comum"> </slot>
  </b-form>
</template>

<script>
import { BForm } from "bootstrap-vue";
export default {
  name: "HcFiltro",
  components: {
    BForm
  },
  props: {
    filtro:{
      type: String,
      default: null
    },
    filtroAvancado: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: "Filtrar"
    },
    cardBox: {
      type: Boolean,
      default: false
    },
    filtrarText: {
      type: String,
      default: "Filtrar"
    },
    limparText: {
      type: String,
      default: "Limpar"
    },
    buscaAvancadaText: {
      type: String,
      default: "Busca Avançada"
    },exibeFiltro:{
      type: Boolean,
      default: true
    }
  },
  data,
  computed: {
    temFiltroAvancado,
    cardClass
  },
  methods: {
    onAbrirFiltroAvancado,
    onLimpar
  }
};

function data() {
  return {
    filtroAvancadoAberto: false
  };
}

function temFiltroAvancado() {
  return this.filtroAvancado && !this.filtroAvancadoAberto;
}

function cardClass() {
  return this.cardBox === true ? "card-box" : "";
}

function onAbrirFiltroAvancado() {
  this.filtroAvancadoAberto = true;
  this.$emit("abrir-avancado");
}

function onLimpar() {
  this.filtroAvancadoAberto = false;
  this.$emit("limpar");
}
</script>
<style scoped>
</style>
